/**
 *  @class
 *  @function FreeShipping
 */
fetch('https://ipinfo.io/json?token=e51c4c93f7c801')
  .then(response => response.json())
  .then(data => {
    console.log('Your Country:', data.country);

    // Only enable free shipping if the country is Australia (AU)
    // if (data.country === 'AU') {
    // if (!customElements.get('free-shipping')) {
    // class FreeShipping extends HTMLElement {
    //   constructor() {
    //     super();
    //   }
    //   connectedCallback() {
    //     let amount_text = this.querySelector('.free-shipping--text span');
    //     let total = parseInt(this.dataset.cartTotal, 10);
    //     let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
    //     let percentage = 1;
    //     this.remainingText = this.querySelector('.free-shipping--text-remaining');
    //     this.fullText = this.querySelector('.free-shipping--text-full');
    //     if (total < minimum) {
    //       percentage = total / minimum;
    //       if (amount_text) {
    //         let remaining = minimum - total,
    //           format = window.theme.settings.money_with_currency_format || "${{amount}}";
    //         amount_text.innerHTML = formatMoney(remaining, format);
    //       }
    //       this.remainingText.style.display = 'none';
    //       this.fullText.style.display = 'block';
    //     } else {
    //       this.remainingText.style.display = 'none';
    //       this.fullText.style.display = 'block';
    //     }
    
    //     this.style.setProperty('--percentage', 1);
    
    //   }
    // }
    // customElements.define('free-shipping', FreeShipping);
    // }
    // } else {}
    if (!customElements.get('free-shipping')) {
    class FreeShipping extends HTMLElement {
    constructor() {
    super();
    }
    connectedCallback() {
    let amount_text = this.querySelector('.free-shipping--text span');
    let total = parseInt(this.dataset.cartTotal, 10);
    let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
    let percentage = 1;
    this.remainingText = this.querySelector('.free-shipping--text-remaining');
    this.fullText = this.querySelector('.free-shipping--text-full');
    if (total < minimum) {
    percentage = total / minimum;
    if (amount_text) {
    let remaining = minimum - total,
      format = window.theme.settings.money_with_currency_format || "${{amount}}";
    amount_text.innerHTML = formatMoney(remaining, format);
    }
    this.remainingText.style.display = 'block';
    this.fullText.style.display = 'none';
    } else {
    this.remainingText.style.display = 'none';
    this.fullText.style.display = 'block';
    }
    
    this.style.setProperty('--percentage', percentage);
    
    }
    }
    customElements.define('free-shipping', FreeShipping);
    }
    
  })
  .catch(error => {
    console.error('Error fetching country:', error);
  });


/**
 *  @class
 *  @function FreeShipping
 */

// if (!customElements.get('free-shipping')) {
//   class FreeShipping extends HTMLElement {
//     constructor() {
//       super();
//     }

//     async connectedCallback() {
//       const country = await this.getCountryByIP();

//       // Show the component only if the country is Australia
//       if (country !== 'Australia') {
//         this.style.display = 'none';
//         return;
//       }

//       let amountText = this.querySelector('.free-shipping--text span');
//       let total = parseInt(this.dataset.cartTotal, 10) || 0;
//       let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1)) || 0;
//       let percentage = 1;

//       this.remainingText = this.querySelector('.free-shipping--text-remaining');
//       this.fullText = this.querySelector('.free-shipping--text-full');

//       if (total < minimum) {
//         percentage = total / minimum;

//         if (amountText) {
//           let remaining = minimum - total;
//           let format = window.theme?.settings?.money_with_currency_format || "${{amount}}";
//           if (typeof formatMoney === 'function') {
//             amountText.innerHTML = formatMoney(remaining, format);
//           } else {
//             amountText.innerHTML = `${Shopify.formatMoney(remaining)}`;
//           }
//         }

//         this.remainingText.style.display = 'block';
//         this.fullText.style.display = 'none';
//       } else {
//         this.remainingText.style.display = 'none';
//         this.fullText.style.display = 'block';
//       }

//       this.style.setProperty('--percentage', percentage);
//     }

//     async getCountryByIP() {
//       try {
//         // Replace with your IP geolocation API service and API key
//         const response = await fetch('https://ipinfo.io/json?token=YOUR_API_KEY');
//         const data = await response.json();
//         return data.country === 'AU' ? 'Australia' : null;
//       } catch (error) {
//         console.error('Error fetching country by IP:', error);
//         return null;
//       }
//     }
//   }

//   customElements.define('free-shipping', FreeShipping);
// }
